import { ComponentProps, SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactNode } from '@tanstack/react-router';
import { actionButtonStyles, ActionButtonStylesVariants } from './variants';
import { match } from 'ts-pattern';
import { Button } from 'react-aria-components';

export type ActionButtonProps = {
  icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
  className?: string;
} & ActionButtonStylesVariants &
  Omit<ComponentProps<typeof Button>, 'className' | 'children' | 'color'>;

export function ActionButton(props: ActionButtonProps) {
  const { icon: Icon, size = 'large', className, ...rest } = props;

  return (
    <Button
      className={twMerge(actionButtonStyles({ size }), className)}
      {...rest}
    >
      <Icon className={twMerge(mapSizeToIconSize(size), 'fill-primaryMain')} />
    </Button>
  );
}

function mapSizeToIconSize(size: ActionButtonStylesVariants['size']): string {
  return match(size)
    .returnType<string>()
    .with('large', () => 'min-w-24 w-24 h-24')
    .with('small', () => 'min-w-16 w-16 h-16')
    .otherwise(() => 'min-w-24 w-24 h-24');
}
